import script from "./SingleStakeTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleStakeTable.vue?vue&type=script&setup=true&lang=ts"

import "./SingleStakeTable.vue?vue&type=style&index=0&id=614a8cf7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-614a8cf7"]])

export default __exports__